import { ContentItem } from '../../../../../../common/components/organisme/DrawerBtnGroup/DrawerBtnGroup';
import FileAPI from '../../../../../../services/fileAPI'
import { useSinglePlanBT } from '../../../../hooks'
import PlanBTImageView from './PlanBTImageView/PlanBTImageView'


export interface PlanBTImagePresenterProps {
  contentWidget?: ContentItem[];
}

export default function PlanBTImagePresenter({contentWidget }: PlanBTImagePresenterProps ) {
  const{singlePlanBTQuery: {data, isLoading}} = useSinglePlanBT()


  if(isLoading) return <div>Loading...</div>

  
  return (
    <PlanBTImageView src={data?.plan_image_file_id ? FileAPI.getFilesURL(data.plan_image_file_id) : undefined} contentWidget={contentWidget}/> 
  )
}
